// src/api/endpoints/tienda.ts — the store owner's own reads (see schemas/tienda.ts).
import { apiRequest } from '@/api/http';
import {
  MyKoHubCase,
  MyListing,
  MyOrder,
  MyPayout,
  MyStore,
  MyStoreResponse,
  Page,
} from '@/api/schemas/tienda';

const PAGE = 50;

/** One page of the app's cursor lists; the panel reads the first 50 and stops. */
export type PageOf<T> = { items: T[]; nextCursor?: string | null };

function qs(params: Record<string, string | number | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== '') p.set(k, String(v));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function getMyStore(): Promise<MyStoreResponse> {
  return apiRequest('/stores/me', { schema: MyStoreResponse });
}

/**
 * `PATCH /stores/:id` (ko-backend#1279) — the pickup instructions buyers read
 * on their order, for the one store named: an owner may have several.
 */
export function updateMyStore(
  storeId: string,
  body: { pickupInstructions: string | null },
): Promise<MyStore> {
  return apiRequest(`/stores/${storeId}`, { method: 'PATCH', body, schema: MyStore });
}

/** The lists take the active store (ko-backend#1279); without one, everything of the owner. */
export interface StoreScopedQuery {
  status?: string;
  storeId?: string;
}

export function listMyListings(query: StoreScopedQuery = {}): Promise<PageOf<MyListing>> {
  return apiRequest(`/users/me/listings${qs({ ...query, limit: PAGE })}`, {
    schema: Page(MyListing),
  });
}

export function listMySales(query: StoreScopedQuery = {}): Promise<PageOf<MyOrder>> {
  return apiRequest(`/orders${qs({ role: 'seller', ...query, limit: PAGE })}`, {
    schema: Page(MyOrder),
  });
}

export function listMyKoHubCases(query: StoreScopedQuery = {}): Promise<PageOf<MyKoHubCase>> {
  return apiRequest(`/kohub/cases${qs({ role: 'seller', ...query, limit: PAGE })}`, {
    schema: Page(MyKoHubCase),
  });
}

export function listMyPayouts(): Promise<PageOf<MyPayout>> {
  return apiRequest(`/wallet/payouts${qs({ limit: PAGE })}`, { schema: Page(MyPayout) });
}
